export const GraphicAspectRatio = {
	AR_16_9: '16:9',
	AR_9_16: '9:16',
	AR_4_5:  '4:5',
	AR_1_1:  '1:1',
	AR_4_3:  '4:3',
};
